<template>
  <v-layout row wrap class="activity-form-container mt-3">
    <input-field
      :label="$tc('Template', 1)"
      :value="activityTemplate"
      variable-name="activitiesTemplates"
      input-type="other"
      size="medium"
    >
      <treeselect
        v-model="activityTemplate"
        @input="updateActivityWithTemplate"
        :options="activityTemplateOptions"
        :load-options="loadActivitiesTemplateOptions"
        :normalizer="activityTemplateNormalizer"
        value-format="object"
        disableFuzzyMatching
        class="form-input-select"
      />
    </input-field>

    <input-field label="" value="" input-type="space" size="small" />

    <input-field
      :label="$t('Title')"
      v-model="newActivity.title"
      variable-name="title"
      input-type="text"
      size="small"
      required
    />

    <input-field
      :label="$t('DueDate')"
      v-model="newActivity.due_date"
      variable-name="due_date"
      input-type="datetime"
      size="small"
      :min="dateNow"
    />
    <input-field
      :label="$t('ApprovalType')"
      input-type="other"
      size="small"
      :value="newActivity.auto_approval"
    >
      <treeselect
        :value="newActivity.auto_approval"
        :options="approvalType"
        @input="updateTasksApprovalType($event)"
        class="form-input-select"
        :disabled="!activityTemplate"
      />
    </input-field>

    <input-field
      :label="$t('Description')"
      v-model="newActivity.description"
      variable-name="description"
      input-type="textarea"
      size="large"
    />

    <!--<input-field
      :label="$tc('Dependency', 2)"
      :value="newActivity.dependencies"
      variable-name="dependencies"
      input-type="other"
      size="large"
    >
      <treeselect
        v-model="newActivity.dependencies"
        :options="dependencyOptions"
        :load-options="loadDependencyOptions"
        :normalizer="dependencyNormalizer"
        multiple
        disableFuzzyMatching
        class="form-input-select"
      />
    </input-field>-->
  </v-layout>
</template>

<script>
import InputField from "@/components/Home/Forms/_Molecules/InputField";
import { mapActions } from "vuex";
import { activitiesTasksDataMixin } from "../../../../../../mixins/field/activitiesTasksDataMixin";

export default {
  name: "ObjectFormActivityCreateForm",

  components: { InputField },

  mixins: [activitiesTasksDataMixin],

  props: {
    /**
     * receives data structure of new activity
     */
    newActivity: {
      type: Object,
      required: true
    },
    /**
     * Layer of selected Object
     */
    objectLayer: {
      type: String
    },
    /**
     * Selected object data with all its properies (tp_height etc...)
     */
    objectData: {
      type: Object
    }
  },

  data() {
    return {
      activityTemplate: null,
      filteredActivityTemplate: null,
      activityTemplateOptions: null,
      dependencyOptions: null
    };
  },

  computed: {
    /**
     * list of approval types
     */
    approvalType() {
      return [
        {
          label: this.$i18n.t("Automatic"),
          id: "automatic",
          isDisabled: true
        },
        {
          label: this.$i18n.t("AutoApproved"),
          id: true
        },
        {
          label: this.$i18n.t("ManualApproval"),
          id: false
        }
      ];
    }
  },

  methods: {
    ...mapActions(["fetchActivityTemplates"]),

    async loadActivitiesTemplateOptions({ callback }) {
      try {
        let options = await this.fetchActivityTemplates();
        this.activityTemplateOptions = this.activityTasksFilter(options);
      } catch (err) {
        console.log(err);
      }

      callback();
    },

    loadDependencyOptions({ callback }) {
      //TODO Implement loadDependencyOptions final version
      callback();
    },

    activityTemplateNormalizer(node) {
      return {
        id: node.uuid,
        label: node.title
      };
    },

    dependencyNormalizer(node) {
      return {
        id: node.id,
        label: node.id + ": " + node.title
      };
    },

    updateActivityWithTemplate() {
      let keysToUpdate = ["title", "description", "tasks"];
      for (let key of keysToUpdate) {
        if (this.activityTemplate) {
          this.activityTemplate.tasks = this.activityTasksFilter(
            this.activityTemplate.tasks
          );
          this.newActivity[key] = this.activityTemplate[key];
        } else {
          this.newActivity[key] = null;
        }
      }
    },
    /**
     * updates tasks auto approval value
     */
    updateTasksApprovalType(value) {
      this.newActivity.tasks.forEach(item => {
        item.auto_approval = value ? true : false;
      });
    },
    /** Searches for all the filled properties that match the field param.
     *
     * @param {Object} object - objectData from selected object
     * @param {String} field - field to look for
     *
     */
    searchObjectProperties(object, field) {
      for (const [key, value] of Object.entries(object)) {
        if (typeof value === "object" && value !== null) {
          let fieldFounded = this.searchObjectProperties(value, field);
          if (fieldFounded) return fieldFounded;
        }
        if (key.includes(field) && value) {
          return value;
        }
      }
    },
    /**
     * filters activities or tasks based on filter and property
     *
     * @param {Array} items - Receives an Array of Activities or Tasks
     */
    activityTasksFilter(items) {
      let filtered = items.filter(activity => {
        if (
          activity.object_type[this.objectLayer] &&
          activity.object_type[this.objectLayer].length > 0
        ) {
          let objectFilter = activity.object_type[this.objectLayer].find(
            item => item.property
          );
          if (objectFilter) {
            let found = this.searchObjectProperties(
              this.objectData,
              objectFilter.property
            );
            if (found == objectFilter.filter) {
              return true;
            }
          }
        } else {
          return activity.object_type[this.objectLayer];
        }
      });

      return filtered;
    }
  }
};
</script>
<style scoped>
.v-input.v-input--checkbox {
  align-items: end !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/Activities/ActivityCreate/ActivityCreateForm.vue